import React, { FC } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button } from '@pandiafi/design-system'

import { FeedbackAndQuestionNoticeListItem } from '../../../common/validations/feedbackAndQuestionNotice'
import { renderEventType } from '../../views/DefectNotice/utils'
import { useContractPaths } from '../../hooks/useContractPaths/useContractPaths'

export const ContactInfoNoticeCard: FC<{
  notice: FeedbackAndQuestionNoticeListItem
}> = ({ notice }) => {
  const { t } = useTranslation(['common', 'contact'])
  const { feedbackViewPath, questionViewPath } = useContractPaths()
  const navigate = useNavigate()

  const title = notice.title || notice.description

  const handleClick = () => {
    if (notice.noticeType === 'feedback') {
      navigate(
        feedbackViewPath.replace(':feedbackQuestionNoticeUuid', notice.uuid)
      )
    } else if (notice.noticeType === 'question') {
      navigate(
        questionViewPath.replace(':feedbackQuestionNoticeUuid', notice.uuid)
      )
    }
  }

  const getNoticeTypeTitle = () => {
    if (notice.noticeType === 'feedback') {
      return t('common:buildingInfo.giveFeedback')
    }
    if (notice.noticeType === 'question') {
      return t('common:buildingInfo.askQuestion')
    }
    return notice.noticeType
  }

  return (
    <div
      onClick={handleClick}
      className={classNames(
        'min-h-16 min-w-80 p-3 rounded-md bg-common-blue-2 relative text-common-gray-7 cursor-pointer hover:outline hover:outline-common-blue-2 hover:outline-offset-2'
      )}
      style={
        {
          '--button-secondary-border-color': 'transparent',
        } as React.CSSProperties
      }
    >
      <div>
        <div className={classNames('flex justify-between')}>
          <div>
            <div className={classNames('font-medium text-sm')}>
              <div>
                {getNoticeTypeTitle()} #{notice.id}
                {title ? ':' : ''}
              </div>
              {title && (
                <div
                  style={{ overflowWrap: 'anywhere', paddingRight: '0.5rem' }}
                >
                  {title}
                </div>
              )}
            </div>
            <div className={classNames('text-sm')}>
              {renderEventType(notice.latestEvent)}
            </div>
          </div>
          <Button
            icon="angle-right"
            onClick={handleClick}
            variant="secondary"
            small
            circle
          />
        </div>
      </div>
    </div>
  )
}
